import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';

const Protected = ({ children }) => {
  const isAuthenticated = localStorage.getItem('token');
  if (isAuthenticated) {
    return <Navigate to="/admin-dashboard" replace />;
  }
  return children;
};

Protected.propTypes = {
  children: PropTypes.element,
};

export default Protected;
